module.exports = __webpack_public_path__ + "media/images/institutional1-a17728b30193cc661ca08560e29b1b0f.png";